import { c as _c } from "react/compiler-runtime";
import type { ApiRepCategory } from "@/generated/models/ApiRepCategory";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { useMemo } from "react";
import OverlappingAvatars from "@/components/common/OverlappingAvatars";
import { getContributorLabel, type RepDirection } from "./UserPageRep.helpers";
export default function RepCategoryPill(t0) {
  const $ = _c(43);
  const {
    category,
    canEdit,
    onEdit,
    onOpenContributors,
    compact: t1,
    direction: t2
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const direction = t2 === undefined ? "received" : t2;
  const paddingClass = compact ? "tw-px-3 tw-py-2" : "tw-px-4 tw-py-2.5";
  const layoutClass = compact ? "tw-inline-flex tw-flex-wrap tw-items-center tw-gap-x-2.5 tw-gap-y-1.5" : "tw-inline-flex tw-flex-wrap tw-items-center tw-gap-x-3 tw-gap-y-2";
  let t3;
  if ($[0] !== category.top_contributors) {
    t3 = category.top_contributors.map(_temp);
    $[0] = category.top_contributors;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const avatarItems = t3;
  let t4;
  if ($[2] !== category.contributor_count) {
    t4 = formatNumberWithCommas(category.contributor_count);
    $[2] = category.contributor_count;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== category.contributor_count || $[5] !== direction) {
    t5 = getContributorLabel(direction, category.contributor_count);
    $[4] = category.contributor_count;
    $[5] = direction;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const contributorText = `${t4} ${t5}`;
  const canOpenContributors = category.contributor_count > 0 && !!onOpenContributors;
  const contributorButtonClasses = compact ? "tw-cursor-pointer tw-whitespace-nowrap tw-border-none tw-bg-transparent tw-p-0 tw-text-xs tw-font-medium tw-text-iron-400 tw-underline tw-decoration-white/20 tw-underline-offset-4 tw-transition-colors hover:tw-text-iron-200" : "tw-cursor-pointer tw-whitespace-nowrap tw-border-none tw-bg-transparent tw-p-0 tw-text-xs tw-font-medium tw-text-iron-400 tw-underline tw-decoration-white/10 tw-underline-offset-4 tw-transition-[text-decoration-color] tw-transition-colors hover:tw-text-iron-200 hover:tw-decoration-white/50";
  let t6;
  if ($[7] !== category.category) {
    t6 = <span className="tw-whitespace-nowrap tw-text-left tw-text-sm tw-font-medium tw-text-white">{category.category}</span>;
    $[7] = category.category;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== category.total_rep) {
    t7 = formatNumberWithCommas(category.total_rep);
    $[9] = category.total_rep;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <span className="tw-text-sm tw-font-medium tw-text-iron-400 tw-transition-colors group-hover:tw-text-iron-300">{t7}</span>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t8) {
    t9 = <span className="tw-inline-flex tw-items-center tw-gap-1.5">{t6}{t8}</span>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== category.authenticated_user_contribution || $[17] !== direction) {
    t10 = category.authenticated_user_contribution !== null && category.authenticated_user_contribution !== 0 && <><span className="tw-text-xs tw-text-white/20">·</span><span className="tw-whitespace-nowrap tw-text-xs tw-font-medium tw-text-iron-400">{direction === "given" ? "Assigned To You:" : "You Assigned:"}{" "}<span className="tw-font-medium tw-text-primary-400">{category.authenticated_user_contribution > 0 && "+"}{formatNumberWithCommas(category.authenticated_user_contribution)}</span></span></>;
    $[16] = category.authenticated_user_contribution;
    $[17] = direction;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const details = t11;
  const baseClasses = `group ${layoutClass} tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-[#18191B] tw-transition-all tw-duration-300 tw-ease-out ${paddingClass}`;
  const t12 = `${baseClasses} ${canEdit ? "hover:tw-border-white/20 hover:tw-bg-white/10 hover:tw-shadow-md" : "tw-cursor-default"}`;
  let t13;
  if ($[22] !== canEdit || $[23] !== category.category || $[24] !== details || $[25] !== onEdit) {
    t13 = canEdit ? <button type="button" onClick={() => onEdit(category.category)} className="tw-inline-flex tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-x-2.5 tw-gap-y-1.5 tw-cursor-pointer tw-border-none tw-bg-transparent tw-p-0 tw-text-left">{details}</button> : <div className="tw-inline-flex tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-x-2.5 tw-gap-y-1.5">{details}</div>;
    $[22] = canEdit;
    $[23] = category.category;
    $[24] = details;
    $[25] = onEdit;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== avatarItems) {
    t14 = avatarItems.length > 0 && <OverlappingAvatars items={avatarItems} size="sm" maxCount={5} />;
    $[27] = avatarItems;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== canOpenContributors || $[30] !== category || $[31] !== contributorButtonClasses || $[32] !== contributorText || $[33] !== direction || $[34] !== onOpenContributors) {
    t15 = canOpenContributors ? <button type="button" onClick={() => onOpenContributors(category)} aria-label={`View all ${getContributorLabel(direction, category.contributor_count)} for ${category.category}`} className={contributorButtonClasses}>{contributorText}</button> : <span className="tw-whitespace-nowrap tw-text-xs tw-font-medium tw-text-iron-400">{contributorText}</span>;
    $[29] = canOpenContributors;
    $[30] = category;
    $[31] = contributorButtonClasses;
    $[32] = contributorText;
    $[33] = direction;
    $[34] = onOpenContributors;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t14 || $[37] !== t15) {
    t16 = <div className="tw-inline-flex tw-items-center tw-gap-1.5">{t14}{t15}</div>;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t12 || $[40] !== t13 || $[41] !== t16) {
    t17 = <div className={t12}>{t13}{t16}</div>;
    $[39] = t12;
    $[40] = t13;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  return t17;
}
function _temp(c) {
  return {
    key: c.profile.handle ?? c.profile.primary_address,
    pfpUrl: c.profile.pfp ?? null,
    href: `/${c.profile.handle ?? c.profile.primary_address}`,
    ariaLabel: c.profile.handle ?? c.profile.primary_address,
    fallback: c.profile.handle ? c.profile.handle.charAt(0).toUpperCase() : "?",
    title: c.profile.handle ?? c.profile.primary_address,
    tooltipContent: <span>{c.profile.handle ?? c.profile.primary_address} ·{" "}{formatNumberWithCommas(c.contribution)}</span>
  };
}